// @ts-check

import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

export const useAppQuery = ({
  url,
  extraQueryKeys = [],
  reactQueryOptions,
}) => {
  const customFetch = useMemo(() => {
    return async () => {
      const response = await fetch(url);
      return response.json();
    };
  }, [url]);

  return useQuery({
    queryKey: [...extraQueryKeys, url].filter(Boolean),
    queryFn: customFetch,
    ...reactQueryOptions,
    refetchOnWindowFocus: false,
  });
};
